(() => {
  class CartUpsell extends HTMLElement {
    constructor() {
      super();
      this.productCount = 3;
      this.swiper = null;
      this.lastCartItemCount = 0;
      this.drawerObserver = null;
      this.cartItemsObserver = null;
    }

    async connectedCallback() {
      await this.fetchRecommendations();
      this.initSwiper();
      this.observeCartChanges();
    }

    disconnectedCallback() {
      if (this.drawerObserver) {
        this.drawerObserver.disconnect();
        this.drawerObserver = null;
      }
      if (this.cartItemsObserver) {
        this.cartItemsObserver.disconnect();
        this.cartItemsObserver = null;
      }
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    async fetchRecommendations() {
      const cartItems = document.querySelectorAll('.cart-product[data-product-id]');
      
      if (cartItems.length === 0) {
        this.hideUpsell();
        return;
      }

      let productId = null;
      for (let i = 0; i < cartItems.length; i++) {
        const item = cartItems[i];
        const isGiftItem = item.hasAttribute('data-gift-item') && 
                           item.getAttribute('data-gift-item') === 'true';
        
        if (!isGiftItem) {
          productId = item.getAttribute('data-product-id');
          break;
        }
      }

      if (!productId) {
        this.hideUpsell();
        return;
      }

      try {
        const response = await fetch(
          // `${window.Shopify?.routes?.root || '/'}recommendations/products?product_id=${productId}&limit=${this.productCount}&section_id=product-recommendations`
          `${window.Shopify?.routes?.root || '/'}recommendations/products?product_id=${productId}&limit=${this.productCount}&intent=complementary&section_id=product-recommendations`
        );
        
        if (!response.ok) {
          throw new Error('Failed to fetch recommendations');
        }

        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const cartSuggestions = html.querySelectorAll('.cart-suggestion');
        
        if (cartSuggestions.length === 0) {
          const productCards = html.querySelectorAll('.product-card');
          
          if (productCards.length === 0) {
            this.hideUpsell();
            return;
          }

        const swiperWrapper = this.querySelector('.swiper-wrapper');
        if (!swiperWrapper) return;

        swiperWrapper.innerHTML = '';

        const productPromises = Array.from(productCards)
          .filter((productCard) => {
            const productLink = productCard.querySelector('a');
            return productLink !== null;
          })
          .map(async (productCard) => {
            const productLink = productCard.querySelector('a');

            const productUrl = productLink.getAttribute('href');
            const productImage = productCard.querySelector('picture img') || productCard.querySelector('img');
            const productInfo = productCard.querySelector('.product-card__info');
            
            if (!productInfo) return;

            const vendor = productInfo.querySelector('span:nth-child(1)')?.textContent || '';
            const title = productInfo.querySelector('span:nth-child(2)')?.textContent || '';
            const price = productInfo.querySelector('span:nth-child(3)')?.textContent || '';

            const imageSrc = productImage?.getAttribute('src') || 
                            productImage?.getAttribute('data-src');
          const productHandle = this.getProductHandleFromUrl(productUrl);
          const variantId = await this.fetchProductVariantId(productHandle);
          
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          
          slide.innerHTML = `
            <article class="cart-suggestion">
              <a href="${productUrl}" class="cart-suggestion-image">
                <img src="${imageSrc}" alt="${title}" class="contain" loading="lazy">
              </a>
              <div class="cart-suggestion-middle">
                <div class="cart-suggestion-text">
                  <span class="body-black text-black text--uppercase">${vendor}</span>
                  <span class="body-light text-black">${title}</span>
                  <span class="body-black text-black">${price}</span>
                </div>
                <div class="cart-suggestion--mobile">
                  ${variantId ? `<buy-button data-variant-id="${variantId}">
                    <button value="Add to cart" class="button button--outline-black button--small">${this.getAddToCartText()}</button>
                  </buy-button>` : `<a href="${productUrl}" class="button button--outline-black button--small">${this.getAddToCartText()}</a>`}
                </div>
              </div>
              <div class="cart-suggestion--desktop">
                ${variantId ? `<buy-button data-variant-id="${variantId}">
                  <button value="Add to cart" class="button button--outline-black button--small">${this.getAddToCartText()}</button>
                </buy-button>` : `<a href="${productUrl}" class="button button--outline-black button--small">${this.getAddToCartText()}</a>`}
              </div>
            </article>
          `;

          return slide;
        });

        const slides = await Promise.all(productPromises);
        slides.filter((slide) => slide !== null && slide !== undefined).forEach((slide) => {
          swiperWrapper.appendChild(slide);
        });

        this.initSwiper();
        } else {
          const swiperWrapper = this.querySelector('.swiper-wrapper');
          if (!swiperWrapper) return;

          swiperWrapper.innerHTML = '';

          cartSuggestions.forEach((cartSuggestion) => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            slide.appendChild(cartSuggestion.cloneNode(true));
            swiperWrapper.appendChild(slide);
          });

          this.initSwiper();
        }

        this.showUpsell();
      } catch (error) {
        this.hideUpsell();
      }
    }

    getProductHandleFromUrl(productUrl) {
      const match = productUrl.match(/\/products\/([^/?]+)/);
      return match ? match[1] : '';
    }

    async fetchProductVariantId(productHandle) {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${productHandle}.js`);
        if (!response.ok) {
          throw new Error('Failed to fetch product');
        }
        const product = await response.json();
        return product.variants && product.variants.length > 0 
          ? product.variants[0].id 
          : product.selected_or_first_available_variant?.id || '';
      } catch (error) {
        return '';
      }
    }

    getAddToCartText() {
      const translations = window.theme?.translations?.misc?.add || 'HINZUFÜGEN';
      return translations;
    }

    initSwiper() {
      const swiperEl = this.querySelector('.js-cart-upsell-swiper');
      if (!swiperEl) return;

      if (this.swiper) {
        this.swiper.destroy(true, true);
      }

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        grabCursor: true,
        threshold: 0,
        touchRatio: 2, 
        slidesPerGroup: 1, 
        freeMode: false, 
        resistance: true, 
        resistanceRatio: 0.1, 
        scrollbar: {
          el: '.js-cart-upsell-scrollbar',
          draggable: true,
        },
      });
    }

    observeCartChanges() {
      const cartDrawer = document.querySelector('.js-cart-drawer');
      if (!cartDrawer) return;

      const initialCartItems = cartDrawer.querySelectorAll('.cart-product[data-product-id]');
      this.lastCartItemCount = initialCartItems.length;

      // Observe cart drawer open state
      this.drawerObserver = new MutationObserver(() => {
        if (cartDrawer.hasAttribute('open')) {
          this.checkCartAndUpdate();
        }
      });

      this.drawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });

      // Observe cart items container for changes instead of polling
      const cartBody = cartDrawer.querySelector('.cart-drawer__body');
      if (cartBody) {
        this.cartItemsObserver = new MutationObserver(() => {
          if (cartDrawer.hasAttribute('open')) {
            this.checkCartAndUpdate();
          }
        });

        this.cartItemsObserver.observe(cartBody, {
          childList: true,
          subtree: true
        });
      }
    }

    checkCartAndUpdate() {
      const cartDrawer = document.querySelector('.js-cart-drawer');
      if (!cartDrawer || !cartDrawer.hasAttribute('open')) return;

      const cartItems = cartDrawer.querySelectorAll('.cart-product[data-product-id]');
      const currentCount = cartItems.length;

      if (currentCount === 0) {
        if (this.lastCartItemCount !== 0) {
          this.lastCartItemCount = 0;
          this.hideUpsell();
        }
        return;
      }

      if (currentCount !== this.lastCartItemCount) {
        this.lastCartItemCount = currentCount;
        
        this.fetchRecommendations().then(() => {
          if (this.swiper) {
            setTimeout(() => {
              this.swiper.update();
              this.swiper.slideTo(0, 0);
            }, 100);
          }
        });
      }
    }


    hideUpsell() {
      const upsellContainer = this.closest('.cart-upsell');
      if (upsellContainer) {
        upsellContainer.style.display = 'none';
      }
    }

    showUpsell() {
      const upsellContainer = this.closest('.cart-upsell');
      if (upsellContainer) {
        upsellContainer.style.display = '';
      }
    }
  }

  if (!customElements.get('cart-upsell')) {
    customElements.define('cart-upsell', CartUpsell);
  }
})();

